export default __webpack_public_path__ + "static/media/audio.83235faf.png";